import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { navbarItems } from "../utils/navbarItems";

import classes from "./MainNavbar.module.css";

const MainNavbar = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className={classes["wrapper"]}>
      <h2 className={classes["title"]}>{t("249-School")}</h2>
      <div className={classes["navbar-items"]}>
        {navbarItems.map((value) => {
          return (
            <a className={classes["item"]} key={value.id} href={value.path}>
              {t(value.title)}
            </a>
          );
        })}
      </div>
      <button
        onClick={() => navigate("/login")}
        className={classes["login-button"]}
      >
        {t("Login")}
      </button>
    </div>
  );
};

export default MainNavbar;
